import {
    List, Collapse, Icon,
    ListItemButton, ListItemIcon,
    ListItemText
} from '@mui/material'

import { Fragment, useRef, useState } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'
import { createId } from '../../../../services/utils'

import { DEFAULT, SELECTED } from '../../../../services/theme'

import Config from '../../../../features/config.json'

import Styles from './style'

export const Submenu = (props) => {
    const navigate = useNavigate()
    const url = useLocation()
    const pathname = url.pathname
    const asPortal = useRef(Config.interface?.navigation?.asPortal ?? false)

    const [open, setOpen] = useState(props.open)

    const handleOpen = (path) => () => {
        setOpen(!open)
        if (path) navigate(path)
    }

    const handleNavigate = (path, target) => () => {
        if (target) return
        navigate(path)
    }

    return (
        <Fragment>
            <ListItemButton
                onClick={handleOpen(props.path)}
                sx={(asPortal.current) ? Styles.mainCtaPortal : Styles.mainCta}
                className={(props.subOpen) ? SELECTED : DEFAULT}
            >
                {(props.icon) && <Icon>{props.icon}</Icon>}
                <ListItemIcon>
                    {asPortal.current && (<Icon>{(open) ? 'expand_more' : 'navigate_next'}</Icon>)}
                </ListItemIcon>
                <ListItemText primary={props.label} />
                {!asPortal.current && (<Icon>{(open) ? 'expand_more' : 'navigate_next'}</Icon>)}
            </ListItemButton>
            <Collapse in={open} timeout={'auto'} unmountOnExit>
                <List component={'div'} disablePadding>
                    {props.items && props.items.length > 0 && props.items.map(subitem => {
                        const key = createId()
                        return (
                            <ListItemButton
                                key={key}
                                onClick={handleNavigate(subitem.path, subitem.target)}
                                className={(subitem.path === pathname) ? SELECTED : DEFAULT}
                                sx={(asPortal.current) ? Styles.subCtaPortal : Styles.subCta}
                                disabled={subitem.disabled}
                            >
                                {(subitem.target === 'blank')
                                    ? (<a href={subitem.path} target={subitem.target} style={Styles.link}><ListItemText primary={subitem.label}/></a>)
                                    : (<ListItemText primary={subitem.label}/>)
                                }
                            </ListItemButton>
                        )
                    })}
                </List>
            </Collapse>
        </Fragment>
    )
}

export default Submenu